import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useLinkedStudiesApi Hook
 *
 * Pure API hook for linked studies / linked submissions / parent request operations.
 *
 * @returns {Object} API methods
 */
const useLinkedStudiesApi = () => {
  const getEligibleLinkedStudies = useCallback(async (workflowVersionId) => {
    const response = await axiosInstance.get(
      `/api/requests/eligible-linked-studies/${workflowVersionId}`
    );
    return response.data;
  }, []);

  const getLinkedStudies = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/linked-studies`
    );
    return response.data;
  }, []);

  const getEligibleParentRequests = useCallback(
    async (workflowVersionId, params = {}) => {
      const response = await axiosInstance.get(
        `/api/requests/eligible-parent-requests/${workflowVersionId}`,
        { params }
      );
      return response.data;
    },
    []
  );

  const getLinkedSubmissions = useCallback(async (requestId, params = {}) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/linked-submissions`,
      { params }
    );
    return response.data;
  }, []);

  const getLinkedSubmissionCount = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/linked-submissions/count`
    );
    return response.data;
  }, []);

  const getRequestParentRequests = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/parent-requests`
    );
    return response.data;
  }, []);

  return {
    getRequestParentRequests,
    getEligibleLinkedStudies,
    getLinkedStudies,
    getEligibleParentRequests,
    getLinkedSubmissions,
    getLinkedSubmissionCount,
  };
};

export default useLinkedStudiesApi;
